import React, { useState } from 'react';
import { Box } from '@mui/material';

import { ScreeningPackageSelector } from '../../../components/molecules/ScreeningPackageSelector';
import { ScreeningPackage } from '../../../types/tenantScreening';

export const stepTitle = 'Choose your screening package';
export const stepDescription =
  'Select the reports you need. You can preview a sample of each package below.';

const ScreeningPackageComponent: React.FC = () => {
  const [selectedPackage, setSelectedPackage] = useState<ScreeningPackage>(
    ScreeningPackage.COMPREHENSIVE
  );

  const handlePackageChange = (packageType: ScreeningPackage) => {
    setSelectedPackage(packageType);
  };

  const packageOptions = [
    {
      type: ScreeningPackage.BASIC,
      name: 'Basic',
      price: 39.99,
      features: [
        'Rental Application',
        'Credit Report & Score',
        'Basic Criminal Background Check',
      ],
      recommended: false,
    },
    {
      type: ScreeningPackage.COMPREHENSIVE,
      name: 'Comprehensive',
      price: 49.99,
      features: [
        'Rental Application',
        'Credit Report & Score',
        'Federal Background Check',
        'Jurisdiction Background Check',
        'Eviction Report',
        'Income Verification',
        'Auto Reference Check',
      ],
      recommended: true,
    },
  ];

  return (
    <Box
      sx={{
        maxWidth: 800,
        margin: '0 auto',
        padding: { xs: 2, md: 4 },
      }}
    >
      <ScreeningPackageSelector
        packages={packageOptions}
        selectedPackage={selectedPackage}
        onPackageChange={handlePackageChange}
        showSampleReportLink={true}
      />
    </Box>
  );
};

export default ScreeningPackageComponent;
